import { render, staticRenderFns } from "./channelDepartment.vue?vue&type=template&id=c14ec3e6&scoped=true"
import script from "./channelDepartment.vue?vue&type=script&lang=js"
export * from "./channelDepartment.vue?vue&type=script&lang=js"
import style0 from "./channelDepartment.vue?vue&type=style&index=0&id=c14ec3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14ec3e6",
  null
  
)

export default component.exports